import React, { Component } from 'react'
import { Formik, Form } from 'formik'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

class PersonaFisicaFormularioComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            apellidoPaterno: '', apellidoMaterno: '',
            nombre: '', rfc: '', curp: '',
            fileCURP: '', fileINE: '', fileCif: '', fileImpresionPantallaIne: '',
            vigenciaIne: '', vigenciaImpresionPantallaIne: '',
            noVigente: false, rfcDesconocido: false,
            loading: false, errors: {},
        }
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("WRITE_PERSONAS_FISICAS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        if (Number(this.props.match.params.id) === -1) return

        ElementsDataService.retrieveElement("personas-fisicas", this.state.id).then(r => {
            const d = r.data
            const noVigente = d.vigenciaIne === '1900-01-01'
            this.setState({
                apellidoPaterno: d.apellidoPaterno || '',
                apellidoMaterno: d.apellidoMaterno || '',
                nombre: d.nombre || '',
                rfc: d.rfc || '',
                curp: d.curp || '',
                fileCURP: d.curpFileUrl || '',
                fileINE: d.ineFileUrl || '',
                fileCif: d.cifFileUrl || '',
                fileImpresionPantallaIne: d.impresionPantallaIneFileUrl || '',
                vigenciaIne: noVigente ? '' : (d.vigenciaIne || ''),
                vigenciaImpresionPantallaIne: d.vigenciaImpresionPantallaIne || '',
                noVigente,
            })
        })
    }

    validate() {
        const { apellidoPaterno, nombre, rfc } = this.state
        const e = {}
        if (!apellidoPaterno) e.apellidoPaterno = 'Requerido'
        if (!nombre) e.nombre = 'Requerido'
        if (!rfc) e.rfc = 'Requerido'
        this.setState({ errors: e })
        return Object.keys(e).length === 0
    }

    onSubmit() {
        if (!this.validate()) return
        this.setState({ loading: true })
        const s = this.state
        const fd = new FormData()
        fd.append('apellidoPaterno', s.apellidoPaterno)
        fd.append('apellidoMaterno', s.apellidoMaterno || '-')
        fd.append('nombre', s.nombre)
        fd.append('rfc', s.rfc)
        fd.append('curp', s.curp || '')
        fd.append('fileCURP', s.fileCURP)
        fd.append('fileINE', s.fileINE)
        fd.append('fileCif', s.fileCif)
        fd.append('fileImpresionPantallaIne', s.fileImpresionPantallaIne)
        fd.append('vigenciaIne', s.noVigente && !s.vigenciaIne ? '1900-01-01' : s.vigenciaIne)
        fd.append('vigenciaImpresionPantallaIne', s.vigenciaImpresionPantallaIne)

        const ok = r => {
            if (r.data.message === 'CREATED') {
                this.props.history.push(`/personas-fisicas/reportes/${r.data.id}`)
            } else {
                alert(r.data.message)
                this.setState({ loading: false })
            }
        }
        if (Number(s.id) === -1) {
            ElementsDataService.createElement("personas-fisicas", fd).then(ok)
        } else {
            ElementsDataService.updateElement("personas-fisicas", s.id, fd).then(ok)
        }
    }

    setUpper = f => e => this.setState({ [f]: e.target.value.toUpperCase(), errors: { ...this.state.errors, [f]: null } })
    set = f => e => this.setState({ [f]: e.target.value })

    render() {
        const { apellidoPaterno, apellidoMaterno, nombre, rfc, curp,
            fileCURP, fileINE, fileCif, fileImpresionPantallaIne,
            vigenciaIne, vigenciaImpresionPantallaIne,
            noVigente, rfcDesconocido, loading, errors } = this.state
        const isNew = Number(this.state.id) === -1

        const fullName = apellidoPaterno
            ? `${apellidoPaterno}${apellidoMaterno ? ' ' + apellidoMaterno : ''}, ${nombre}`
            : isNew ? 'Nueva Persona Física' : 'Editar Persona Física'

        // Avatar
        const initials = ((apellidoPaterno || '').charAt(0) + (nombre || '').charAt(0)).toUpperCase() || '?'
        const avatarColors = ['#3b82f6','#8b5cf6','#ec4899','#f59e0b','#10b981','#06b6d4']
        const avatarBg = avatarColors[(apellidoPaterno || '').charCodeAt(0) % avatarColors.length] || '#3b82f6'

        return (
            <div style={S.root}>
                <style>{css}</style>
                <div className="pff-root" style={S.inner}>

                    {/* Header */}
                    <div style={S.header}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                            <div style={{ width: 52, height: 52, borderRadius: '50%', background: avatarBg, color: 'white', fontSize: '1.1rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: `0 4px 14px ${avatarBg}55` }}>
                                {initials}
                            </div>
                            <div>
                                <p style={S.breadcrumb}>
                                    <span style={{ color: '#3b82f6', cursor: 'pointer' }} onClick={() => this.props.history.push('/personas-fisicas')}>Personas Físicas</span>
                                    <span style={{ margin: '0 8px', color: '#cbd5e1' }}>›</span>
                                    <span>{isNew ? 'Nueva' : 'Editar'}</span>
                                </p>
                                <h1 style={S.title}>{fullName}</h1>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <button className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                            <button className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                {loading ? '⏳ Guardando...' : '✓ Guardar'}
                            </button>
                        </div>
                    </div>

                    <Formik initialValues={{}} onSubmit={this.onSubmit} enableReinitialize>
                        {() => (
                            <Form autoComplete="off" encType="multipart/form-data">

                                {/* ── 1. Datos personales ── */}
                                <Section icon="👤" title="Datos Personales">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 14 }}>
                                        <div>
                                            <label className="pff-label">Apellido Paterno *</label>
                                            <input className={`pff-input${errors.apellidoPaterno ? ' err' : ''}`}
                                                value={apellidoPaterno} onChange={this.setUpper('apellidoPaterno')}
                                                placeholder="APELLIDO PATERNO" autoComplete="off" />
                                            {errors.apellidoPaterno && <p className="pff-err">⚠ {errors.apellidoPaterno}</p>}
                                        </div>
                                        <div>
                                            <label className="pff-label">Apellido Materno</label>
                                            <input className="pff-input" value={apellidoMaterno}
                                                onChange={this.setUpper('apellidoMaterno')}
                                                placeholder="APELLIDO MATERNO" autoComplete="off" />
                                        </div>
                                        <div>
                                            <label className="pff-label">Nombre(s) *</label>
                                            <input className={`pff-input${errors.nombre ? ' err' : ''}`}
                                                value={nombre} onChange={this.setUpper('nombre')}
                                                placeholder="NOMBRE(S)" autoComplete="off" />
                                            {errors.nombre && <p className="pff-err">⚠ {errors.nombre}</p>}
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                                <label className="pff-label" style={{ margin: 0 }}>RFC *</label>
                                                <label className="toggle-wrap" onClick={() => {
                                                    const val = !rfcDesconocido
                                                    this.setState({ rfcDesconocido: val, rfc: val ? 'XXXXXXXXXXXXX' : '', errors: { ...errors, rfc: null } })
                                                }}>
                                                    <button type="button" className={`toggle ${rfcDesconocido ? 'on' : 'off'}`} />
                                                    <span style={{ fontSize: '0.75rem', color: '#64748b' }}>RFC desconocido</span>
                                                </label>
                                            </div>
                                            <input className={`pff-input${errors.rfc ? ' err' : ''}`}
                                                value={rfc} onChange={this.setUpper('rfc')}
                                                placeholder="RFC" autoComplete="off"
                                                disabled={rfcDesconocido}
                                                style={rfcDesconocido ? { background: '#f8fafc', color: '#94a3b8' } : {}} />
                                            {errors.rfc && <p className="pff-err">⚠ {errors.rfc}</p>}
                                        </div>
                                        <div>
                                            <label className="pff-label">CURP</label>
                                            <input className="pff-input" value={curp || ''}
                                                onChange={this.setUpper('curp')}
                                                placeholder="CURP" autoComplete="off" />
                                        </div>
                                    </div>
                                </Section>

                                {/* ── 2. INE ── */}
                                <Section icon="🪪" title="INE">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                                        <FileField
                                            label="Archivo INE"
                                            existing={fileINE}
                                            onChange={f => this.setState({ fileINE: f })}
                                            id="pff-file-ine"
                                        />
                                        <FileField
                                            label="Impresión Pantalla INE"
                                            existing={fileImpresionPantallaIne}
                                            onChange={f => this.setState({ fileImpresionPantallaIne: f })}
                                            id="pff-file-pantalla-ine"
                                        />
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                                <label className="pff-label" style={{ margin: 0 }}>Vigencia INE</label>
                                                <label className="toggle-wrap" onClick={() => this.setState({ noVigente: !noVigente, vigenciaIne: !noVigente ? '' : vigenciaIne })}>
                                                    <button type="button" className={`toggle ${noVigente ? 'on' : 'off'}`} />
                                                    <span style={{ fontSize: '0.75rem', color: '#64748b' }}>No vigente</span>
                                                </label>
                                            </div>
                                            <input className="pff-input" type="date" value={vigenciaIne}
                                                onChange={this.set('vigenciaIne')}
                                                disabled={noVigente}
                                                style={noVigente ? { background: '#f8fafc', color: '#94a3b8' } : {}} />
                                            {noVigente && (
                                                <p style={{ margin: '4px 0 0', fontSize: '0.72rem', color: '#f59e0b' }}>⚠ Se guardará como INE sin vigencia</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className="pff-label">Vigencia Impresión Pantalla INE</label>
                                            <input className="pff-input" type="date"
                                                value={vigenciaImpresionPantallaIne}
                                                onChange={this.set('vigenciaImpresionPantallaIne')} />
                                        </div>
                                    </div>
                                </Section>

                                {/* ── 3. CURP y CIF ── */}
                                <Section icon="📋" title="CURP y CIF">
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                                        <FileField
                                            label="Archivo CURP"
                                            existing={fileCURP}
                                            onChange={f => this.setState({ fileCURP: f })}
                                            id="pff-file-curp"
                                        />
                                        <FileField
                                            label="Archivo CIF"
                                            existing={fileCif}
                                            onChange={f => this.setState({ fileCif: f })}
                                            id="pff-file-cif"
                                        />
                                    </div>
                                </Section>

                                {/* Footer */}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 24 }}>
                                    <button type="button" className="btn-cancel" onClick={() => this.props.history.goBack()}>Cancelar</button>
                                    <button type="button" className="btn-save" onClick={this.onSubmit} disabled={loading}>
                                        {loading ? '⏳ Guardando...' : '✓ Guardar Persona Física'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        )
    }
}

/* ── Componentes auxiliares ── */
const Section = ({ icon, title, children }) => (
    <div style={{ background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 14, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 22px', borderBottom: '1px solid #f1f5f9', background: '#fafcff' }}>
            <span>{icon}</span>
            <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 700, color: '#1e293b' }}>{title}</h2>
        </div>
        <div style={{ padding: '18px 22px' }}>{children}</div>
    </div>
)

const FileField = ({ label, existing, onChange, id }) => {
    const isUrl = typeof existing === 'string' && existing.startsWith('http')
    const isFile = existing && existing.name
    return (
        <div>
            <label className="pff-label">📎 {label}</label>
            <div className="pff-file-zone" onClick={() => document.getElementById(id).click()}>
                <span style={{ fontSize: '1.1rem' }}>📁</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: 0, fontSize: '0.82rem', fontWeight: 600, color: isFile ? '#3b82f6' : '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {isFile ? existing.name : 'Seleccionar archivo...'}
                    </p>
                    {isUrl && (
                        <a href={existing} target="_blank" rel="noopener noreferrer"
                            style={{ fontSize: '0.72rem', color: '#3b82f6', textDecoration: 'none' }}
                            onClick={e => e.stopPropagation()}>
                            📄 Ver archivo actual ↗
                        </a>
                    )}
                </div>
            </div>
            <input id={id} type="file" style={{ display: 'none' }}
                onChange={e => e.currentTarget.files[0] && onChange(e.currentTarget.files[0])} />
        </div>
    )
}

const css = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    .pff-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
    .pff-label { font-size: 0.68rem; font-weight: 700; color: #64748b; letter-spacing: 0.8px; text-transform: uppercase; display: block; margin-bottom: 5px; }
    .pff-input {
        width: 100%; padding: 9px 13px; background: white; border: 1px solid #e2e8f0;
        border-radius: 10px; font-size: 0.875rem; color: #1e293b; outline: none;
        transition: all 0.2s; font-family: 'Inter', sans-serif; text-transform: uppercase;
    }
    .pff-input.no-upper { text-transform: none; }
    .pff-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .pff-input.err { border-color: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,0.08); }
    .pff-input:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
    .pff-err { font-size: 0.72rem; color: #ef4444; margin-top: 4px; }
    .pff-file-zone {
        display: flex; align-items: center; gap: 10px;
        border: 1.5px dashed #e2e8f0; border-radius: 10px; padding: 12px 14px;
        background: #f8fafc; cursor: pointer; transition: all 0.2s;
    }
    .pff-file-zone:hover { border-color: #3b82f6; background: #eff6ff; }
    .toggle-wrap { display: flex; align-items: center; gap: 7px; cursor: pointer; }
    .toggle { width: 34px; height: 18px; border-radius: 9px; border: none; cursor: pointer; transition: background 0.2s; position: relative; flex-shrink: 0; }
    .toggle::after { content: ''; position: absolute; top: 2px; left: 2px; width: 14px; height: 14px; border-radius: 50%; background: white; transition: left 0.2s; }
    .toggle.on { background: #3b82f6; }
    .toggle.on::after { left: 18px; }
    .toggle.off { background: #cbd5e1; }
    .btn-save { padding: 11px 28px; background: linear-gradient(135deg, #2563eb, #3b82f6); border: none; border-radius: 10px; color: white; font-weight: 700; font-size: 0.88rem; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif; box-shadow: 0 4px 14px rgba(59,130,246,0.3); }
    .btn-save:hover:not(:disabled) { transform: translateY(-1px); }
    .btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
    .btn-cancel { padding: 11px 20px; background: white; border: 1px solid #e2e8f0; border-radius: 10px; color: #64748b; font-weight: 600; font-size: 0.88rem; cursor: pointer; font-family: 'Inter', sans-serif; }
    .btn-cancel:hover { border-color: #94a3b8; color: #334155; }
`

const S = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 860, margin: '0 auto' },
    header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    breadcrumb: { margin: '0 0 4px', fontSize: '0.78rem', color: '#94a3b8' },
    title: { margin: 0, fontSize: '1.3rem', fontWeight: 700, color: '#0f172a' },
}

export default PersonaFisicaFormularioComponent
